import type { DeepString } from "@/lib/i18n";

/**
 * CVideoGalleryOuter - polskie tłumaczenia (galeria filmów - lista + film).
 */
export const pl = {
  emptyData: "Brak danych do wyświetlenia.",
  emptyList: "Brak filmów dla podanych kryteriów wyszukiwania.",
  searchPlaceholder: "Wyszukaj...",
  backToList: "<- Powrót do listy filmów",
  unsupportedVideo: "Otwórz film w nowym oknie",
  /** `paginationLabel(2, 7)` -> "Strona 2 z 7". */
  paginationLabel: (page: number, totalPages: number) =>
    `Strona ${page} z ${totalPages}`,
  prevPage: "Poprzednia",
  nextPage: "Następna",
} as const;

export type CVideoGalleryOuterTranslations = DeepString<typeof pl>;
